/***
 *
 *   GRID
 *   Responsive one-to-six column grid layout
 *
 *   PROPS
 *   cols: number of columns (default: 2, max: 6)
 *
 **********/

import { type CSSProperties, type ReactNode } from 'react';
import { ClassHelper } from 'components/lib';
import Style from './grid.module.scss';

interface GridProps {
  cols?: number | string;
  gap?: number | string;
  extraClass?: string;
  customStyle?: CSSProperties;
  children?: ReactNode;
}

export function Grid(props: GridProps) {
  const cols: Record<string, boolean> = {};
  const colNames = ['one', 'two', 'three', 'four', 'five', 'six'];

  if (props.cols) {
    for (let i = 0; i < parseInt(`${props.cols}`); i++) cols[colNames[i]] = true;
  }

  const css = ClassHelper(Style, { ...cols, ...{ grid: true } });

  const children = props.children;

  return (
    <section className={`${css} ${props.extraClass}`} style={props.customStyle}>
      {Array.isArray(children) && children.length > 1 ? children.map((child) => child) : children}
    </section>
  );
}
